<template>
  <el-row>
    <el-row>
      <el-col :span="2">
        <h6 style="text-align: left">当前库存明细: </h6>
      </el-col>
      <el-col :span="2" :offset="20" v-if="this.$store.state.CurrentUser != 'reader'">
        <el-button size="mini" type="primary" style="margin-bottom: 5px" @click="toggleActivate"><i class="el-icon-plus"></i></el-button>
      </el-col>
    </el-row>

    <el-row style="margin: 10px 0px; border: 1px solid #eee; border-radius: 5px; background-color: #eee" v-if="showAddStock">
      <el-form ref="form" :model="oilOptForm" label-width="90px" style="text-align: left; padding: 10px 0px;">
        <el-form-item>
          <el-row>
            <el-col :span="2">机油类型</el-col>
            <el-col :span="6">
              <el-select v-model="oilOptForm.type" placeholder="请选择">
                <el-option
                  v-for="item in oilTypes"
                  :key="item"
                  :label="item.name"
                  :value="item.id">
                </el-option>
              </el-select>
            </el-col>
          </el-row>
        </el-form-item>
        <el-form-item>
          <el-row>
            <el-col :span="2">机油件数</el-col>
            <el-col :span="4">
              <el-input v-model="oilOptForm.amount" placeholder="机油件数">
                <template slot="append">件</template>
              </el-input>
            </el-col>
            <el-col :span="2" :offset="1">单件容量</el-col>
            <el-col :span="5">
              <el-input v-model="oilOptForm.volume" placeholder="单件多少升">
                <template slot="append">升</template>
              </el-input>
            </el-col>
            <el-col :span="2" :offset="5">
              <el-button type="primary" @click="onClickSendStocks"><i class="el-icon-shopping-cart-1"></i> 发货</el-button>
            </el-col>
            <el-col :span="2">
              <el-button type="warning" @click="onClickAddStocks"><i class="el-icon-shopping-cart-2"></i> 新增库存</el-button>
            </el-col>
          </el-row>
        </el-form-item>
      </el-form>
    </el-row>

    <el-table
      :data="oilStocks"
      border
      style="width: 100%">
      <el-table-column
        prop="id"
        label="编号"
        width="80">
      </el-table-column>
      <el-table-column
        prop="id"
        label="机油编号"
        width="80">
        <template slot-scope="scope">
          {{ scope.row.oil.id }}
        </template>
      </el-table-column>
      <el-table-column
        prop="name"
        label="名称">
        <template slot-scope="scope">
          {{ scope.row.oil.name }}
        </template>
      </el-table-column>
      <el-table-column
        prop="amount"
        label="当前余量">
        <template slot-scope="scope">
          {{ scope.row.amount }} 升
        </template>
      </el-table-column>
    </el-table>

    <h6 style="text-align: left; margin-top: 20px">库存更新详情: </h6>
    <el-table
      :data="oilUpdateHistories.slice((oilUpdateHistoriesForm.page - 1) * oilUpdateHistoriesForm.pageSize,
      oilUpdateHistoriesForm.page * oilUpdateHistoriesForm.pageSize)"
      border
      style="width: 100%">
      <el-table-column
        prop="id"
        label="编号">
      </el-table-column>
      <el-table-column
        prop="oil"
        label="机油编号">
      </el-table-column>
      <el-table-column
        prop="preVolume"
        label="当前容量">
        <template slot-scope="scope">
          {{ scope.row.preVolume }}升
        </template>
      </el-table-column>
      <el-table-column
        prop="amount"
        label="增量">
        <template slot-scope="scope">
          {{ scope.row.delta }}升
        </template>
      </el-table-column>
      <el-table-column
        prop="reason"
        label="类型">
        <template slot-scope="scope">
          {{ updateReason[scope.row.reason] }}
        </template>
      </el-table-column>
      <el-table-column
        prop="createAt"
        label="时间">
      </el-table-column>
    </el-table>
    <el-pagination
      class="pagination"
      v-if="totalOilUpdateHistoriesElements > 0"
      background
      layout="prev, pager, next"
      :current-page.sync="oilUpdateHistoriesForm.page"
      :page-size="oilUpdateHistoriesForm.pageSize"
      :total="totalOilUpdateHistoriesElements">
    </el-pagination>

    <h6 style="text-align: left; margin-top: 20px">当前待收货列表: </h6>
    <el-table
      :data="oilFlows"
      border
      style="width: 100%">
      <el-table-column
        prop="id"
        label="编号"
        width="80">
      </el-table-column>
      <el-table-column
        prop="id"
        label="机油编号"
        width="80">
        <template slot-scope="scope">
          {{ scope.row.oil.id }}
        </template>
      </el-table-column>
      <el-table-column
        prop="name"
        label="名称">
        <template slot-scope="scope">
          {{ scope.row.oil.name }}
        </template>
      </el-table-column>
      <el-table-column
        prop="amount"
        label="发货数量">
        <template slot-scope="scope">
          {{ scope.row.amount }} 件
        </template>
      </el-table-column>
      <el-table-column
        prop="amount"
        label="单件容量">
        <template slot-scope="scope">
          {{ scope.row.volume }} 升
        </template>
      </el-table-column>
      <el-table-column
        prop="et"
        label="发货时间">
        <template slot-scope="scope">
          {{ scope.row.et }}
        </template>
      </el-table-column>
    </el-table>

    <h6 style="text-align: left; margin-top: 20px">库存发货申请: </h6>
    <el-table
      :data="oilRequests"
      border
      style="width: 100%">
      <el-table-column
        prop="id"
        label="编号"
        width="80">
      </el-table-column>
      <el-table-column
        prop="id"
        label="机油编号"
        width="80">
        <template slot-scope="scope">
          {{ scope.row.oil.id }}
        </template>
      </el-table-column>
      <el-table-column
        prop="name"
        label="名称">
        <template slot-scope="scope">
          {{ scope.row.oil.name }}
        </template>
      </el-table-column>
      <el-table-column
        prop="amount"
        label="发货数量">
        <template slot-scope="scope">
          {{ scope.row.amount }} 件
        </template>
      </el-table-column>
      <el-table-column
        prop="amount"
        label="单件容量">
        <template slot-scope="scope">
          {{ scope.row.volume }} 升
        </template>
      </el-table-column>
      <el-table-column
        prop="et"
        label="请求时间">
        <template slot-scope="scope">
          {{ scope.row.et }}
        </template>
      </el-table-column>

      <el-table-column
        label="#">
        <template slot-scope="scope">
          <el-button v-if="currentUser != 'reader'" @click="onApproveOilRequest(scope.row.id)" type="success"><i class="el-icon-check"></i> 通过</el-button>
          <el-button v-if="currentUser != 'reader'" @click="onDeclineOilRequest(scope.row.id)" type="danger"><i class="el-icon-close"></i> 拒绝</el-button>
          <div v-else>#</div>
        </template>
      </el-table-column>
    </el-table>

    <el-dialog
      title="温馨提示"
      :visible.sync="confirmSendStocks"
      width="30%">
      <span>发货给商家后，需要商家在管理后台确认，确认后会将发货数量累加到当前库存里面！</span>
      <span slot="footer" class="dialog-footer">
            <el-button @click="confirmSendStocks = false">取 消</el-button>
            <el-button type="primary" @click="sendStocks">确 定</el-button>
          </span>
    </el-dialog>

    <el-dialog
      title="温馨提示"
      :visible.sync="confirmAddStocks"
      width="30%">
      <span>新增库存是在当前的库存基础上，直接增加或者减少库存，主要用于库存的校对！</span>
      <span slot="footer" class="dialog-footer">
            <el-button @click="confirmAddStocks = false">取 消</el-button>
            <el-button type="primary" @click="updateStocks">确 定</el-button>
          </span>
    </el-dialog>
  </el-row>
</template>

<script>
import * as api from "@/js/api.js"

export default {
  name: "OilManagement",
  props: {
    providerId: String,
    oilTypes: Array,
    oilStocks: Array,
    oilUpdateHistories: Array,
    totalOilUpdateHistoriesElements: Number,
    oilFlows: Array,
    oilRequests: Array
  },
  data() {
    return {
      oilUpdateHistoriesForm: {
        page: 1,
        pageSize: 10
      },
      oilOptForm: {
        type: '',
        amount: '0',
        volume: '0'
      },
      updateReason: {
        '1': '补货',
        '2': '保养',
        '3': '管理员手动更新'
      },

      showAddStock: false,
      confirmSendStocks: false,
      confirmAddStocks: false,
      currentUser: this.$store.state.CurrentUser
    }
  },

  methods: {
    onDeclineOilRequest(id) {
      this.doOilRequestAudit(id, false)
    },

    onApproveOilRequest(id) {
      this.doOilRequestAudit(id, true)
    },

    toggleActivate() {
      this.showAddStock = !this.showAddStock
    },

    onClickSendStocks() {
      this.confirmSendStocks = true
    },

    onClickAddStocks() {
      this.confirmAddStocks = true
    },

    sendStocks() {
      this.confirmSendStocks = false

      const params = {
        opt: '0',
        oilType: this.oilOptForm.type,
        amount: this.oilOptForm.amount,
        volume: this.oilOptForm.volume,
        providerId: this.providerId
      }
      api.providerUpdateStocks(params).then(res => {
        let result = res.data
        if (result.error) {
          this.$message.error('后台服务出错');
        } else {
          this.$message.success('操作成功')
          this.$emit('refresh')
        }
      })
    },

    updateStocks() {
      this.confirmAddStocks = false

      const params = {
        opt: '1',
        oilType: this.oilOptForm.type,
        amount: this.oilOptForm.amount,
        volume: this.oilOptForm.volume,
        providerId: this.providerId
      }
      api.providerUpdateStocks(params).then(res => {
        let result = res.data
        if (result.error) {
          this.$message.error('后台服务出错');
        } else {
          this.$message.success('操作成功')
          this.$emit('refresh')
        }
      })
    },

    doOilRequestAudit(id, status) {
      const params = {
        requestId: id,
        approved: status
      }

      api.providerOilRequestAudit(params).then(res => {
        let result = res.data
        if (result.error) {
          this.$message.error('后台服务出错');
        } else {
          this.$message.success('操作成功')
          this.$emit('refresh')
        }
      })
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/providers/oil/OilStockManagement.vue